/*
 * Public API Surface of microapp-home
 */

export * from './lib/microapp-home.service';
export * from './lib/microapp-home.module';
